/**
 * Sanitiza o HTML de respostas de FAQ removendo apenas elementos e atributos
 * perigosos (scripts, event handlers, javascript: URLs).
 *
 * Tags bloqueadas: script, style, iframe, object, embed, form, input, button,
 *                  textarea, select, meta, link, base, noscript, template
 * Atributos bloqueados: todos os event handlers (on*), srcdoc
 * Protocolos bloqueados em href/src/action: javascript:, data:, vbscript:
 */

const BLOCKED_TAGS = new Set([
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'form',
  'input',
  'button',
  'textarea',
  'select',
  'meta',
  'link',
  'base',
  'noscript',
  'template',
]);

const URL_ATTRS = new Set(['href', 'src', 'action', 'formaction', 'data']);
const DANGEROUS_PROTOCOLS = /^(javascript:|data:|vbscript:)/i;

function sanitizeElement(el: Element): void {
  const tagName = el.tagName.toLowerCase();

  if (BLOCKED_TAGS.has(tagName)) {
    el.remove();

    return;
  }

  // Remove atributos perigosos
  for (const attr of Array.from(el.attributes)) {
    // Bloqueia todos os event handlers (onclick, onload, onerror, etc.)
    if (attr.name.toLowerCase().startsWith('on')) {
      el.removeAttribute(attr.name);
      continue;
    }

    // Bloqueia srcdoc (pode executar scripts em iframes, mas iframes já são bloqueados)
    if (attr.name.toLowerCase() === 'srcdoc') {
      el.removeAttribute(attr.name);
      continue;
    }

    // Bloqueia protocolos perigosos em atributos de URL
    if (URL_ATTRS.has(attr.name.toLowerCase())) {
      const value = attr.value.trim().replace(/\s/g, '');

      if (DANGEROUS_PROTOCOLS.test(value)) {
        el.removeAttribute(attr.name);
      }
    }
  }

  // Garante rel="noopener noreferrer" em links com target="_blank"
  if (tagName === 'a' && el.getAttribute('target') === '_blank') {
    el.setAttribute('rel', 'noopener noreferrer');
  }

  for (const child of Array.from(el.children)) {
    sanitizeElement(child);
  }
}

export function sanitizeFaqAnswer(html: string): string {
  if (!html || typeof html !== 'string') return '';

  // Ambiente Node.js (SSR): sem DOM disponível, retorna o HTML original.
  // A sanitização real ocorre no client onde o DOM está disponível.
  if (typeof document === 'undefined') return html;

  const wrapper = document.createElement('div');

  wrapper.innerHTML = html;

  for (const child of Array.from(wrapper.children)) {
    sanitizeElement(child);
  }

  return wrapper.innerHTML;
}
